'use client'

import type { MouseEvent } from 'react'
import { cn } from '@/lib/utils'
import { OPEN_COOKIE_SETTINGS_EVENT } from '@/lib/identity/consent-prompt'

/** Where the link goes with no JavaScript, or when no banner is mounted to open. */
export const COOKIE_SETTINGS_FALLBACK_HREF = '/privacy-choices'

/**
 * Footer link "Your privacy choices" on every page (Counsel G3 2026-10-22,
 * spec section 3). A click opens the Choices dialog in place through
 * OPEN_COOKIE_SETTINGS_EVENT. The banner marks the event handled
 * (preventDefault); only then is the navigation cancelled, so a page without
 * the banner, or a browser without JavaScript, follows the plain href to the
 * choices section of /privacy.
 */
export function CookieSettingsLink({ className }: { className?: string }) {
  function onClick(event: MouseEvent<HTMLAnchorElement>) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return
    const open = new CustomEvent(OPEN_COOKIE_SETTINGS_EVENT, { cancelable: true })
    if (!window.dispatchEvent(open)) event.preventDefault()
  }
  return (
    <a href={COOKIE_SETTINGS_FALLBACK_HREF} className={cn(className)} onClick={onClick}>
      Your privacy choices
    </a>
  )
}
